import { defineMessages } from 'gatsby-plugin-react-intl';

// add manual topic title overrides to this file
// need to call defineMessages here so babel's static analyzer picks up new messages
const topicTitleMessages = defineMessages({
  'prospectus.layout.page.title_format.information_technology': {
    id: 'prospectus.layout.page.title_format.information_technology',
    description: 'Topic page title',
    defaultMessage: 'Learn Information Technology with Online IT Courses',
  },
});

// add slug:key mapping for all manual overrides here as well
const translationKeysBySlug = {
  'information-technology': 'prospectus.layout.page.title_format.information_technology',
};

export {
  topicTitleMessages,
  translationKeysBySlug,
};
